import React, { useState, useEffect, useMemo } from "react";
import { useRouter } from 'next/router'

import cookies from 'next-cookies'

import Layout from '../../../components/Layout'
import ErrorView from '../../../components/ErrorView'
import SEO from '../../../components/SEO'

import { JobAPI } from "../../../lib/ladder"
import DomainHandler from "../../../lib/domainHandler"

import JobView from "../../../components/JobView"

export async function getServerSideProps(context) {
  const authToken = cookies(context).auth_token;
  const identifier = context.params.job;

  if(!authToken) DomainHandler.redirectToRoot(context);

  const data = await JobAPI.view(authToken, identifier) 

  return { props: { data: data} }
}

export default function Jobs({data}) {
  const router = useRouter();
  const employer = router.query.employer;
  const [barHeight, setBarHeight] = useState(450)

  if(!data || !data.success) return(<ErrorView statusCode={data.statusCode} type={"job"}/>)

  useEffect(() => {
    window.scrollTo(0, 0)
    if(data.success) router.push(`/e/${data.job.employer_slug}/` + data.job.slug)
  }, [])

  useEffect(() => {
    if(document.body.scrollWidth < 768){
      setBarHeight(1000)
    } else {
      setBarHeight(480)
    }
  })

  let seoTitle = (data.job.name + " - " + data.job.location)
  let seoDescription = "Find 1000s of electrical jobs like this at meetladder.com"
  let seoImage = (data.job.logo ? data.job.logo.path : null)

  return(
    <Layout height={barHeight}  color={data.job.primary_color || "#333"} employerLogo={data.job.logo ? data.job.logo.path : null} brandLink={"/e/" + data.job.employer_slug}>
      <SEO title={seoTitle} description={seoDescription} path={`/e/${data.job.employer_slug}/` + data.job.slug} publicVersion={true} image={seoImage}/>
      <JobView jobData={data.job} applied={data.applied}/>
    </Layout>
  )
}